import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui'
import 'normalize.css/normalize.css'
import './assets/theme/index.css'
import './assets/ali-icont/iconfont.css'
 import './assets/ali-icont/icon/new/iconfont.css'
import './assets/styles/index.scss'
import router from './router'
import Config from './config'
import Api from './api'
import * as Methods from './api/methods'
import App from './App.vue'
import qs from 'qs'
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css'
import PubSubJs from 'pubsub-js'
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'
import request from './api/myRequest'
import {gloading} from './util/gloading'




Vue.prototype.openLoading = gloading
Vue.prototype.$Api = Api
Vue.prototype.$Methods = Methods
Vue.prototype.$Config = Config
Vue.prototype.$conf = Config
Vue.prototype.$qs = qs
Vue.prototype.$axios = axios
Vue.prototype.$pubsub = PubSubJs
Vue.prototype.$request = request
// mounts 可以设置['cookie', 'browse', 'locat']
Vue.use(VXEUtils, XEUtils)
Vue.use(ElementUI)



router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title ? to.meta.title + '-' + Config.siteName : Config.siteName;
    next();
    if (!sessionStorage.getItem(Config.USER_NAME_KEY) && to.path != '/login' && to.path != '/pud' &&  to.path != '/restPassword' ) {
        next({path: '/login'});
    } else {
        next();
    }
});
new Vue({
    el: '#app',
    router,
    store,
    template: '<App></App>',
    components: {App}
})





// WEBPACK FOOTER //
// ./src/main.js